import { OsDeploymentEnvironment } from 'environment/common'
import { devEnvironment } from 'environment/dev'
import { prodEnvironment } from 'environment/prod'

export const environment = process.env.PROD ? prodEnvironment : devEnvironment

export const isProductionLike = () =>
  [OsDeploymentEnvironment.Prod, OsDeploymentEnvironment.PreProd].includes(environment.ENV)
